import {
    // issueLog fetch type:
    ISSUE_LOG_FETCH_PROCESSING,
    ISSUE_LOG_FETCH_SUCCESS,
    ISSUE_LOG_FETCH_FAILED,
    ISSUE_LOG_FETCH_CLEAR,
  
    // issue update type:
    ISSUE_LOG_UPDATE_SUCCESS,
    ISSUE_LOG_UPDATE_FAILED,
  } from '../constants';
  import { issueLog } from '../data';
  
  /* ===============================================
   *    Fetch issueLog
   * =============================================== */
  
  // setStateIssueLogFetchToProcessing()
  const setStateIssueLogFetchToProcessing = () => ({
    type: ISSUE_LOG_FETCH_PROCESSING,
  });
  
  /**
   * setStateIssueLogFetchToSuccess()
   * @param {*} payload
   */
  const setStateIssueLogFetchToSuccess = (payload) => ({
    type: ISSUE_LOG_FETCH_SUCCESS,
    payload,
  });
  
  /**
   * setStateIssueLogFetchToFailed()
   * @param {} payload
   */
  const setStateIssueLogFetchToFailed = (payload) => ({
    type: ISSUE_LOG_FETCH_FAILED,
  });
  
  /**
   * setStateIssueLogFetchToClear()
   */
  const setStateIssueLogFetchToClear = () => ({
    type: ISSUE_LOG_FETCH_CLEAR,
  });
  
  /**
   * getIssueLog()
   * @param {object} params
   * @param {object} params.package base64 of props {lang, issue_id, orderByAcs = true }
   * @returns
   */
  export const getIssueLog = (params) => {
    return async (dispatch, getState) => {
      dispatch(setStateIssueLogFetchToProcessing());
      try {
        // issueLogs (getList)
        let logs = await issueLog.getList(params);
  
        dispatch(
          setStateIssueLogFetchToSuccess(logs)
        );
      } catch (error) {
        dispatch(setStateIssueLogFetchToFailed());
        throw error;
      }
    };
  };
  
  /* ===============================================
   *  Add/Update issueLog consist of
   *  - update issueLog data (without isLoading, no setStateIssueLogFetchToProcessing)
   * =============================================== */
  const setStateIssueLogUpdateToSuccess = (payload) => ({
    type: ISSUE_LOG_UPDATE_SUCCESS,
    payload: payload,
  });
  
  const setStateIssueLogUpdateToFailed = () => ({
    type: ISSUE_LOG_UPDATE_FAILED,
  });

  /**
   *  updateIssueLog()
   * @param {object} data , comment data type obect
   * @returns
   */
  export const updateIssueLog = (params) => {
    return async (dispatch, getState) => {
      try {
        // Get issueLogs updated 
        let logs = await issueLog.getList(params);

        // Then setStateIssueLogUpdateToSuccess by logs
        dispatch(
          setStateIssueLogUpdateToSuccess(logs)
        );
      } catch (error) {
        dispatch(setStateIssueLogUpdateToFailed());
        throw error;
      }
    };
  };